import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalibrationlogoEnum } from 'app/enum/calibrationlogoEnum';
import { CalibrationService } from 'app/services/models/calibration.service';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import { CertificateService } from 'app/services/models/certificate.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import QRCode from 'qrcode';
import * as pdfjsLib from 'pdfjs-dist';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { CoreConfigService } from '@core/services/config.service';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from 'app/services/models/company.service';
import { ToastrService } from 'ngx-toastr';
import { PdfFontService } from 'app/services/common/pdf-font.service';
import { PersonService } from 'app/services/models/person.service';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { _acreditionCompanyId, _isPersonId } from 'app/services/auth.service';
import { GetCustomerSettingDetailDTO } from 'app/dtos/customer-setting/getCustomerSettingDetailDTO';
import { Router } from '@angular/router';
import { CustomerSettingService } from 'app/services/models/customer-setting.service';
import { PDFDocument } from 'pdf-lib';


@Component({
  selector: 'app-create-certificate-dialog',
  templateUrl: './create-certificate-dialog.component.html',
  styleUrls: ['./create-certificate-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateCertificateDialogComponent implements OnInit {

  @Input() data: { calibrationId: number; };
  calibration: any = {};
  certificateForm: FormGroup; // Form için tanımlama
  public coreConfig: any;
  private _unsubscribeAll: Subject<any>;
  //calibrationDevice: any = {};
  company: any = {};
  persons: any[] = [];
  calPersons: any[] = [];
  selectedPersonId: number = null;

  akradetionOrganization = [
    { id: 1, name: "Türkak" },
    { id: 2, name: "NAC" },
    { id: 3, name: "İzlenebilirik" },
    { id: 4, name: "IAS" }
  ];

  totalPages = 0;
  img: string[] = [];
  pdfDoc: any = null; // PDF dosyasını tutacak
  isPdfDoc: boolean = false;

  date3 = Number(_acreditionCompanyId) == 1 ? moment().add(1, 'day').toDate() : moment().toDate();
  date4 = moment().add(1, 'year').toDate();

  public dateTimeCertificateStartOptions: FlatpickrOptions = {
    altInput: true,
    altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeCertificateEndOptions: FlatpickrOptions = {
    altInput: true,
    altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };


  turkakQrBase64;
  certificationBodyDocumentNumber: string = null;
  isSaving = false;
  qrCodeBase64: string;

  certificateFirstNo: string = null;

  constructor(
    public activeModal: NgbActiveModal,
    private _coreConfigService: CoreConfigService,
    private fb: FormBuilder,
    @Inject('backendUrl') private backendUrl: string,
    private pdfFontService: PdfFontService,
    private personService: PersonService,
    private calibrationService: CalibrationService,
    private toastrService: ToastrService,
    private certificateReservationService: CertificateReservationService,
    private deliveryDeviceService: DeliveryDeviceService,
    private companyService: CompanyService,
    private router: Router,
    private certificateService: CertificateService,
    private customerSettingService: CustomerSettingService,
  ) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
    //pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/js/pdf.worker.js';
    this._unsubscribeAll = new Subject();
  }

  certificateNumber: string = null;
  certificateReservations?: any[] = [];
  pageCount: number = 2;

  date = new Date();
  date2 = moment().add(1, 'year').toDate();

  measurementResultBase64: any = null;;

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  async ngOnInit() {
    this.certificateForm = this.fb.group({
      certificateNo: [this.certificateNumber],
      issueDate: ['', Validators.required],
      expiryDate: ['', Validators.required],
      visualAndFunctional: [true],
      personId: [null, Validators.required]
    });
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });

    await this.getByIdCalibration(this.data.calibrationId);
  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  logo = null;
  getByIdLogo(number: number): string | null {
    const logos = Object.values(CalibrationlogoEnum);
    this.logo = logos[number - 1] || null;
    return this.logo;
  }

  calCompanyPerson = [];
  async getAllPerson(codes?: string[]) {
    const data = await this.personService.getAllCompaniesPersons(0, 500, 1, codes);
    console.log(data);
    if (codes.includes("calibratonperson")) {
      this.calCompanyPerson = data.persons.map(person => ({
        ...person,
        fullName: person.name + ' ' + person.lastName
      }));
      if (this.calCompanyPerson?.length === 1) {
        this.certificateForm.patchValue({
          personId: this.calCompanyPerson[0].id
        })
      }
    }
    if (codes.includes("calibratedConfirming")) {
      this.persons = data.persons.map(person => ({
        ...person,
        fullName: person.name + ' ' + person.lastName
      }));
      const pers = this.persons?.find(p => p.id === Number(_isPersonId));
      if (pers != null)
        this.selectedPersonId = pers?.id ?? null;

      //this.selectedPersonId = this.persons[0]?.id
    }
  }

  isLoading = false;

  async getByIdCalibration(id) {
    this.isLoading = true;

    try {
      const data = await this.calibrationService.getByIdReadyCalibration(id);
      this.calibration = data;
      console.log(this.calibration);
      const fileName =
        `${this.calibration.deviceSeriNo ? this.calibration.deviceSeriNo + '-' : ''}` +
        `${this.calibration.deviceCode}-${this.calibration.deliveryCode}`;
      await this.getCalibrationMeasurementResultBase64(fileName);

    } catch (error) {
      console.error(error);
      this.toastrService.error("Kalibrasyon bilgileri alınamadı");
    } finally {
      this.isLoading = false;
      const missingFields = [];
      if (!this.calibration.deviceSeriNo) missingFields.push("Seri Numarası");
      if (!this.calibration.deviceBrand) missingFields.push("Marka");
      if (!this.calibration.deviceModel) missingFields.push("Model");
      if (!this.calibration.deviceResolution) missingFields.push("Çözünürlük");
      if (!this.calibration.devicePlace) missingFields.push("Yer");
      if (!this.calibration.deviceInventoryNumber) missingFields.push("Envanter No");
      if (!this.calibration.deviceReferenceMax && !this.calibration.deviceReferenceMin)
        missingFields.push("Cihaz Referans Aralığı");

      if (missingFields.length > 0) {
        this.toastrService.warning(
          `Kalibrasyon yapılan cihazın şu bilgileri eksik: ${missingFields.join(", ")}`,
          "Eksik Bilgi Uyarısı",
          {
            progressBar: true,
            closeButton: true
          }
        );
      }
    }
  }

  formatDateForFile(dateString: string): string {
    if (!dateString) return '';

    const d = new Date(dateString);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hour = String(d.getHours()).padStart(2, '0');
    const minute = String(d.getMinutes()).padStart(2, '0');
    const second = String(d.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hour}${minute}${second}`;
  }

  async getCalibrationMeasurementResultBase64(path: string) {
    var result = await this.calibrationService.getCalibrationMeasurementResultBase64(path);
    console.log(result);
    if (result.base64 != null)
      this.measurementResultBase64 = await this.convertPdfPagesToImages(result.base64);

    //await this.loadPdfFromBase64(this.measurementResultBase64);
  }

  async getAllCertificateReservations(companyId) {
    const data = await this.certificateReservationService.getByIdCompanyCertificateReservations(companyId);
    this.certificateReservations = data;
    console.log(this.certificateReservations);
  }

  onReservationSelect(reservation: any) {
    console.log(reservation);
    if (reservation) {
      this.certificateNumber = reservation.reservedCertificateNo;

    }
  }

  async pdfDetail(isSave: boolean) {
    this._coreConfigService.setConfig({ emitEvent: true });
    this.getByIdLogo(this.calibration.accreditationOrganization)
    const logoKey = Object.keys(CalibrationlogoEnum);
    const key = logoKey[this.calibration.accreditationOrganization - 1];
    Object.keys(this.coreConfig.akraditasyonCompanies).find(k => k === key);
    const value = this.coreConfig.akraditasyonCompanies[key];
    console.log(value);
    if (this.calibration.akraditationCompanyFile) {
      if (!this.calibration.akraditationCompanyFile.startsWith('data:image/png;base64,')) {
        this.calibration.akraditationCompanyFile = 'data:image/png;base64,' + this.calibration.akraditationCompanyFile;
      }
    }

    const issueDate: Date = new Date(this.calibration.calibrationDate);
    const year = issueDate.getFullYear().toString().slice(-2); // Yılın son iki basamağını al
    const month = (issueDate.getMonth() + 1).toString().padStart(2, '0'); // Ayı iki basamağa tamamla
    const formattedDate = month + '.' + year;

    this.certificateNumber = this.calibration.certificateNo;

    const headerBilgi: headerBilgileri = {
      akraditationNo: value ?? '',
      akraditationFirma: this.calibration.accreditationOrganization ?? '',
      certificateNo: this.certificateNumber,
      certificateTarih: formattedDate,
      firmaAdi: this.calibration.akraditationCompany,
      firmaAdresi: this.calibration.akraditationCompanyAddres ?? '',
      firmaLogo: this.calibration.akraditationCompanyFile ?? '',
      acradtionOrganizationId: this.calibration.accreditationOrganization
    }

    const calibrationDate = new Date(this.calibration.calibrationDate);
    const formattedCalibrationDate = `${calibrationDate.getDate().toString().padStart(2, '0')}.${(calibrationDate.getMonth() + 1).toString().padStart(2, '0')}.${calibrationDate.getFullYear()}`;

    const confirmedPerson = this.calibration.personName + " " + this.calibration.personLastName;
    console.log(confirmedPerson)

    const calibrationData: CalibrationData = {
      deviceOwner: this.calibration.certficateCompany,
      address: this.calibration.certificateCompanyAddress ?? '',
      orderNumber: this.calibration.transactionManagementNo,
      deviceName: this.calibration.deviceName,
      manufacturer: this.calibration.deviceBrand,
      modelType: this.calibration.deviceModel,
      serialNumber: this.calibration.deviceSeriNo + '\t' + (this.calibration.deviceInventoryNumber != null ? '/' : '') + '\t' + (this.calibration.deviceInventoryNumber ?? ''),
      calibrationDate: formattedCalibrationDate,
      certificateNo: this.certificateNumber,
      firstPageDescription: (this.calibration.firstPageDescriptions && this.calibration.firstPageDescriptions.length > 0)
        ? (this.calibration.accreditationOrganization == 3 ? this.calibration.firstPageDescriptions[2].description :
          this.calibration.firstPageDescriptions[0].description)
        : '',
      kalYapan: this.calibration.person,
      onaylayan: confirmedPerson ?? '',
      certificatePageNumber: this.pageCount + this.totalPages,
      firtsPageFooterDescription: (this.calibration.firstPageDescriptions && this.calibration.firstPageDescriptions.length > 1)
        ? this.calibration.firstPageDescriptions[1].description
        : '',
      place: this.calibration.devicePlace ?? ''
    };

    const referenceString = (this.calibration.deviceReferenceMin && this.calibration.deviceReferenceMax && this.calibration.deviceReferenceUnitType)
      ? `${this.calibration.deviceReferenceMin}-${this.calibration.deviceReferenceMax} ${this.calibration.deviceReferenceUnitType}`
      : '-';
    const deliveryDate = new Date(this.calibration.deliveryDate);

    const formattedDeliveryDate = `${deliveryDate.getDate().toString().padStart(2, '0')}.${(deliveryDate.getMonth() + 1).toString().padStart(2, '0')}.${deliveryDate.getFullYear()}`;

    const references: Reference[] = this.calibration.calibrationReferencesDevices?.map(device => ({
      deviceName: device.deviceName,
      brand: device.brandName,  // 'brandName' -> 'brand'
      model: device.modelName,  // 'modelName' -> 'model'
      serialNumber: device.seriNo,  // 'seriNo' -> 'serialNumber'
      certificateNumber: device.referenceDeviceMovement.calibrationNo,  // 'calibrationNo' -> 'certificateNumber'
      calibrationDate: this.formatDate(device.referenceDeviceMovement.calibrationDate),  // Format edilmiş tarih
      tracebility: device.referenceDeviceMovement.traceability  // 'traceability' -> 'tracebility'
    }));

    const calibrationDataPage2: CalibrationPage2 = {
      device: {
        deviceName: this.calibration.deviceName,
        serialNo: this.calibration.deviceSeriNo,
        deviceNumber: this.calibration.inventoryNumber ?? '-',
        location: this.calibration.devicePlace ?? '-',
        brand: this.calibration.deviceBrand,
        type: this.calibration.deviceModel,
        range: this.calibration.isPlace ? 'Yerinde' : formattedDeliveryDate, //referenceString, referans aralığıydı artık onun yerine tarih geldi buraya
        resolution: this.calibration.deviceResolution ?? '-',
        incomingDateOfDeviceLaboratory: this.calibration.placeAddress, //this.calibration.isPlace ? 'Yerinde' : formattedDeliveryDate,
        visualFunctionInspectionDevice: this.calibration.visualAndFunctional ? 'Uygun' : 'Uygun Değil'

        // BURASI KALİBRASYON TABLOSUNA EKLENECEK UYGUN OLUP OLMADIĞI
      },
      references: references ?? [],
      evironmentalConditions: this.calibration.enviromentalContents,
      calibrationMethod: this.calibration.calibrationMethodDescription,
      remarks: this.calibration.procedureDescription,
      compliance: this.calibration.conformityDeclartion,
      measurement: this.calibration.measurementUncertaintyDescription,
      measurementUncertainty: this.calibration.measurementUncertaintyDescription,
      description: this.calibration.calibrationMethodDescription
    };

    this.customerSetting = await this.customerSettingService.getCustomerSettingDetail(1);
    await this.generatePDF(headerBilgi, calibrationData, calibrationDataPage2, isSave);
  }

  formatDate(date: string): string {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Aylar 0'dan başladığı için +1 yapıyoruz
    const year = newDate.getFullYear();
    return `${day}.${month}.${year}`;  // Gün.Ay.Yıl formatı
  }

  onFileSelected2(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files ? fileInput.files[0] : null;
    this.img = [];

    const container = document.getElementById('pdf-container');
    if (container) {
      container.innerHTML = '';  // Eski görselleri temizle
    }

    if (file) {
      // PDF Blob oluşturma ve iframe (Önizleme için)
      const pdfBlob = new Blob([file], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "800px";
      iframe.src = pdfUrl;
      container?.appendChild(iframe);

      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        const typedArray = new Uint8Array(e.target?.result as ArrayBuffer);

        // pdf.js ile PDF'i yükle
        pdfjsLib.getDocument(typedArray).promise.then(pdf => {
          this.pdfDoc = pdf;
          this.totalPages = pdf.numPages;
          const canvasArray: string[] = new Array(this.totalPages); // Sayfa sırasını korumak için
          let pagesRendered = 0;

          const renderPage = (pageNum: number) => {
            pdf.getPage(pageNum).then(page => {
              const scale = 4.0; // Kaliteyi artırmak için ölçek
              const viewport = page.getViewport({ scale: scale });

              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d')!;

              canvas.height = viewport.height;
              canvas.width = viewport.width;
              context.imageSmoothingEnabled = false;

              // Sayfayı render et
              page.render({
                canvasContext: context,
                viewport: viewport
              }).promise.then(() => {
                // HATA DÜZELTMESİ: cropCanvas yerine doğrudan render edilen ana canvas kullanılır.
                // Böylece PDF sayfası kırpılmadan tam haliyle alınır.
                const imgData = canvas.toDataURL('image/png');
                canvasArray[pageNum - 1] = imgData;

                pagesRendered++;

                // Tüm sayfalar render edildiğinde işlemleri bitir
                if (pagesRendered === this.totalPages) {
                  this.img = canvasArray.filter(img => img !== undefined);
                  this.openAllPagesInNewTabs(this.img);
                }
              });
            });
          };

          // Sayfaları render etmeye başla
          for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
            renderPage(pageNum);
          }
        });
      };

      reader.readAsArrayBuffer(file);
    }
  }

  openAllPagesInNewTabs(imgDataArray: string[]) {
    const container = document.getElementById('pdf-container');  // Sayfada görselleri ekleyeceğimiz container

    imgDataArray.forEach(imgData => {
      const imgElement = document.createElement('img');
      imgElement.src = imgData;  // Base64 görseli img etiketi kaynağı olarak ayarlıyoruz
      imgElement.style.width = '100%';  // Görselin genişliğini sayfaya uyacak şekilde ayarlıyoruz
      imgElement.style.marginBottom = '20px';  // Sayfalar arasında boşluk bırakıyoruz
      container?.appendChild(imgElement);  // Görseli container'a ekliyoruz
    });
  }



  /*async loadPdfFromBase64(base64Pdf: string) {
    this.img = [];

    const container = document.getElementById('pdf-container');
    if (container) container.innerHTML = '';

    // Base64 → ArrayBuffer
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const typedArray = new Uint8Array(byteNumbers);

    // PDF yükle
    const pdf = await pdfjsLib.getDocument(typedArray).promise;
    this.totalPages = pdf.numPages;

    const canvasArray: string[] = [];

    const renderPage = async (pageNum: number) => {
      const page = await pdf.getPage(pageNum);

      const scale = 4.0;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      context.imageSmoothingEnabled = false;

      await page.render({ canvasContext: context, viewport }).promise;

      // Kırpma canvası oluştur
      const cropCanvas = document.createElement('canvas');
      const cropContext = cropCanvas.getContext('2d')!;

      const cropTop = 340;
      const cropBottom = 390;

      const cropHeight = canvas.height - cropTop - cropBottom;
      const cropWidth = canvas.width;

      cropCanvas.width = cropWidth;
      cropCanvas.height = cropHeight;

      cropContext.drawImage(
        canvas,
        0, cropTop,       // kaynak başlangıç
        cropWidth, cropHeight,
        0, 0,
        cropWidth, cropHeight
      );

      const imgData = cropCanvas.toDataURL('image/png');
      canvasArray[pageNum - 1] = imgData;

      // Eğer tüm sayfalar tamamlandıysa → göster
      if (canvasArray.filter(x => x).length === this.totalPages) {
        this.img = canvasArray;
        this.openAllPagesInNewTabs(canvasArray);
      }
    };

    // Tüm sayfaları sırayla render et
    for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
      renderPage(pageNum);
    }
  }*/

  // Bu kısmı generatePDF dışında bir yerde tanımlamalısınız
  async convertPdfPagesToImages(pdfBase64: string): Promise<any[]> {
    if (!pdfBase64) return [];

    const pdfData = atob(pdfBase64);
    const pdfContainer = document.getElementById('pdf-container');

    if (!pdfContainer) {
      console.warn('PDF önizleme konteyneri (#pdf-container) bulunamadı.');
    } else {
      pdfContainer.innerHTML = '';
      const header = document.createElement('h3');
      header.textContent = 'Ölçüm Sonuçları PDF Önizlemesi';
      pdfContainer.appendChild(header);
    }

    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const numPages = pdf.numPages;
    const imagesArray: any[] = [];
    const scaleFactor = 4.0; // Yüksek kalite

    for (let i = 1; i <= numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: scaleFactor });

      // TAM SAYFA RENDER
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Sayfayı hiçbir kesme işlemi olmadan tam olarak çiziyoruz
      await page.render({ canvasContext: context, viewport: viewport }).promise;

      // Önizleme konteynerine ekle (Kırpılmamış tam haliyle)
      if (pdfContainer) {
        canvas.style.maxWidth = '100%';
        canvas.style.height = 'auto';
        canvas.style.border = '1px solid #ccc';
        canvas.style.margin = '10px 0';

        const pageHeader = document.createElement('h4');
        pageHeader.textContent = `Sayfa ${i} (Tam Sayfa)`;
        pdfContainer.appendChild(pageHeader);
        pdfContainer.appendChild(canvas);
      }

      // Base64 formatına dönüştür
      const base64Image = canvas.toDataURL('image/jpeg', 0.95);

      imagesArray.push({
        image: base64Image,
        width: 570, // A4 genişliği
        //pageBreak: 'after', // Her ölçüm görseli yeni bir sayfada başlasın
        //margin: [0, -60, 0, 0] // İstediğiniz üst boşluk ayarı
      });
    }

    return imagesArray;
  }

  customerSetting: GetCustomerSettingDetailDTO;
  async generatePDF(headerData: headerBilgileri, calibrationData: CalibrationData, calibrationPage2: CalibrationPage2, isSave: boolean = false) {
    // Convert image paths to Base64 asynchronously
    //const measurementImages = await this.convertPdfPagesToImages(this.measurementResultBase64);
    await this.pdfFontService.loadFonts();
    calibrationData.certificatePageNumber = this.pageCount + this.totalPages;

    const pdfImages = (this.measurementResultBase64 || []).map(img => ({
      image: img.image,
      width: img.width,
      pageBreak: img.pageBreak,
      height:645,
      margin: [-20, -110, 0, 0]
    }));
    // headerData.firmaLogo = await this.convertImageToBase64(headerData.firmaLogo) || '';
    let akraditasyonFirma = '';
    if (headerData.akraditationFirma === 1) {
      if (this.customerSetting.turkakLogo != null)
        akraditasyonFirma = this.customerSetting.turkakLogo;
    } else if (headerData.akraditationFirma === 2) {
      if (this.customerSetting.nacLogo != null)
        akraditasyonFirma = this.customerSetting.nacLogo;
    }
    else if (headerData.akraditationFirma === 3) {
      if (this.customerSetting.traceabilityLogoPath != null)
        akraditasyonFirma = this.customerSetting.traceabilityLogoPath
    } else if (headerData.akraditationFirma === 4) {
      if (this.customerSetting.iasLogo != null)
        akraditasyonFirma = this.customerSetting.iasLogo
    }
    calibrationData.certificatePageNumber += pdfImages?.length;
    /*
  if (headerData.akraditationFirma == 1 || headerData.akraditationFirma == 2 || headerData.akraditationFirma == 3) {
    const akraditasyonLogoPath = this.getByIdLogo(headerData.akraditationFirma);
    akraditasyonFirma = await this.convertImageToBase64(akraditasyonLogoPath) || '';
  }*/

    // Document definition
    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [35, 215, 35, 90],
      background: (currentPage, pageSize) => {
        if (!this.company.companyFile64) return null;
        return {
          image: `${headerData.firmaLogo}`,
          width: 450,
          opacity: 0.1,
          absolutePosition: { x: 75, y: 300 }
        };
      },
      // Header for each page
      header: (currentPage, pageCount, pageSize) => {
        return this.getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData);
      },
      defaultStyle: {
        font: 'RobotoSerif', // Using the custom font
      },
      // Content of the document (multiple pages)
      content: [
        await this.createCalibrationPageContent(calibrationData, true),
        this.createCalibrationPage2(calibrationPage2),
        ...pdfImages
        //this.createCalibrationOtherPage(this.img)
      ],
      // Footer for each page
      footer: (currentPage, pageCount) => this.getFooterContent(currentPage, pageCount, calibrationData.firtsPageFooterDescription)
    }
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition as unknown as TDocumentDefinitions);


    if (isSave) {
      this.isSaving = true; // işlem başladı
      try {
        pdfDocGenerator.getBase64(async (base64Data) => {
          try {
            const data = await this.certificateService.saveCertificateBase64(
              this.calibration.certificateId,
              base64Data,
              headerData.certificateNo,
              this.calibration.calibrationNo
            );

            if (data.status) {
              this.closeModal(true);
              this.router.navigate(['/admin/delivery']);
              this.toastrService.success(data.message);
            } else {
              this.toastrService.error(data.message);
            }
          } catch (innerError) {
            console.error('Certificate creation error:', innerError);
            this.toastrService.error('Sertifika oluşturulurken bir hata oluştu.');
          } finally {
            this.isSaving = false; // işlem tamamlandı
          }
        });
      } catch (error) {
        console.error('PDF generation error:', error);
        this.toastrService.error('PDF oluşturulurken bir hata oluştu.');
        this.isSaving = false;
      }
    } else {

      pdfDocGenerator.open();
    }

    // Generate and open the PDF
  }

  async generateQRCode(certificateNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const url = `${this.backendUrl}api/Certificates/verify/${this.calibration.calibrationNo}-${certificateNo}.pdf`;

    try {
      const qrCanvas = document.createElement('canvas');
      await QRCode.toCanvas(qrCanvas, url, { width: 250 });

      // 2️⃣ Yeni bir canvas oluştur (QR + metin için)
      const finalCanvas = document.createElement('canvas');
      const ctx = finalCanvas.getContext('2d')!;
      const qrSize = qrCanvas.width;
      const textHeight = 40; // alt boşluk
      finalCanvas.width = qrSize;
      finalCanvas.height = qrSize + textHeight;

      // 3️⃣ QR kodu çiz
      ctx.drawImage(qrCanvas, 0, 0);

      // 4️⃣ Metni çiz
      ctx.font = 'bold 32px Arial';
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(certificateNo, qrSize / 2, qrSize + 30);

      // 5️⃣ Base64 çıktısı al
      this.qrCodeBase64 = finalCanvas.toDataURL('image/png');
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }

  async createCalibrationPageContent(calibrationData: CalibrationData, pageBreak: boolean) {
    let firstPageDescriptionToHtml = htmlToPdfmake(calibrationData.firstPageDescription);
    firstPageDescriptionToHtml = this.applyDefaultFontSize(firstPageDescriptionToHtml, 8, 7);

    //const seal = await this.convertImageToBase64('/assets/logo/muhur.png').catch(err => console.log(err));
    //const imza1 = await this.convertImageToBase64('/assets/logo/e-imza.png').catch(err => console.log(err));
    let seal = this.customerSetting.stampImage;
    await this.generateQRCode(calibrationData.certificateNo);
    return [
      {
        table: {
          widths: ['30%', '70%'], // İlk sütun başlık, ikinci sütun veri
          body: [
            [{ text: 'Cihaz Sahibi / Adresi', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceOwner}`, fontSize: 9 }],
            [{ text: 'Customer / Address', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, { text: `${calibrationData.address}`, fontSize: 7 }],

            [{ text: 'Sipariş Numarası', bold: true, fontSize: 9 }, { text: `${calibrationData.orderNumber ?? '-'}`, fontSize: 9 }],
            [{ text: 'Order No', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Cihaz', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceName}`, fontSize: 9 }],
            [{ text: 'Device', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'İmalatçı', bold: true, fontSize: 9 }, { text: `${calibrationData.manufacturer}`, fontSize: 9 }],
            [{ text: 'Brand', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Model / Tip', bold: true, fontSize: 9 }, { text: `${calibrationData.modelType}`, fontSize: 9 }],
            [{ text: 'Type', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: `Seri Numarası / Envanter No`, bold: true, fontSize: 9 }, { text: `${calibrationData.serialNumber}`, fontSize: 9 }],
            [{ text: 'Serial Number / Inventory Number', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Kalibrasyon Tarihi', bold: true, fontSize: 9 }, { text: `${calibrationData.calibrationDate}`, fontSize: 9 }],
            [{ text: 'Date of Calibration', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Sertifika Sayfa Sayısı', bold: true, fontSize: 9 }, { text: `${calibrationData.certificatePageNumber}`, fontSize: 9 }],
            [{ text: 'Number of Pages of The Certificate', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            // [{ text: 'Bulunduğu Yer', bold: true, fontSize: 9 }, { text: `${calibrationData.place}`, fontSize: 9 }],
            // [{ text: 'Location Of Equipment', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],
          ]
        },
        layout: 'noBorders', // Tablo çizgilerini kaldırdım
        margin: [0, -10, 0, 1],
      },
      {
        stack: [firstPageDescriptionToHtml],
        margin: [0, 5, 0, 10]
      },
      {
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [{ text: "Mühür", bold: true, fontSize: 8, alignment: 'center' }, { text: 'Yayımlanma Tarihi', bold: true, fontSize: 8, alignment: 'center' }, { text: "Kalibrasyon Yapan", bold: true, fontSize: 8, alignment: 'center' }, { text: "Onaylayan", bold: true, fontSize: 8, alignment: 'center' }],
            [{ text: "Seal", fontSize: 6, alignment: 'center', italics: true }, { text: 'Issue Date', fontSize: 8, alignment: 'center', italics: true }, { text: "Calibrated by", fontSize: 6, alignment: 'center', italics: true }, { text: "Approval", fontSize: 6, alignment: 'center', italics: true }],
            [
              { image: seal, fit: [85, 85], alignment: 'center' },
              { text: `${new Date(this.calibration.issueDate).toLocaleDateString('tr-TR')}`, fontSize: 10, alignment: 'center', marginTop: 15 },
              [
                { text: calibrationData.kalYapan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                {
                  text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000',
                }
              ],
              [
                { text: calibrationData.onaylayan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                {
                  text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000'
                },
                {
                  text: `${calibrationData.calibrationDate}`,
                  fontSize: 8,
                  alignment: 'center'
                }
              ],
            ]
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 0],
      },
      pageBreak ? { text: '', pageBreak: 'after' } : { text: '' },
    ];
  }

  applyDefaultFontSize(obj: any, normalFontSize: number = 7, smallFontSize: number = 5) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item, normalFontSize, smallFontSize));
    } else if (typeof obj === "object" && obj !== null) {
      // If the object contains text and doesn't have fontSize defined
      if (obj.text && !obj.fontSize) {
        // Apply the normal font size by default
        obj.fontSize = normalFontSize;
      }

      // Adjust the font size if 'ql-size-small' is present in style
      if (obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = smallFontSize; // Apply small font size
      }

      // If the object has margin, reduce it by 10%
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1);
      }

      // Recursively apply the function to nested properties
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key], normalFontSize, smallFontSize);
      });
    }
    return obj;
  }

  createCalibrationPage2(calibrationPage2: CalibrationPage2) {
    let calibrationText = htmlToPdfmake(calibrationPage2.description);
    calibrationText = this.applyDefaultFontSize(calibrationText);

    let remaksToHtml = htmlToPdfmake(calibrationPage2.remarks);
    remaksToHtml = this.applyDefaultFontSize(remaksToHtml);

    let complianceToHtml = htmlToPdfmake(calibrationPage2.compliance);
    complianceToHtml = this.applyDefaultFontSize(complianceToHtml);

    let measurementToHtml = htmlToPdfmake(calibrationPage2.measurement);
    measurementToHtml = this.applyDefaultFontSize(measurementToHtml);
    return [
      {
        stack: [
          {
            text: [
              {
                text: "Kalibre Edilen Cihaz /", bold: true, fontSize: 10,
              },
              {
                text: "Device to be calibrate", fontSize: 8, italics: true
              },
            ],
            margin: [0, 0, 0, 0]
          },
          {
            columns: [
              {
                table: {
                  widths: ['50%', '50%'], // İki sütunlu tablo
                  body: [
                    // İlk tablo: Cihaz bilgileri
                    [{ text: 'Cihaz Adı / Device Name', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceName}`, fontSize: 8 }],
                    [{ text: 'Seri Numarası / Serial No', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.serialNo}`, fontSize: 8 }],
                    [{ text: 'Cihaz No / Device No', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceNumber}`, fontSize: 8 }],
                    [{ text: 'Bulunduğu Yer / Location', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.location}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              {
                table: {
                  widths: ['50%', '50%'], // İkinci tablo: Model ve ölçüm bilgileri
                  body: [
                    [{ text: 'Marka / Brand', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.brand}`, fontSize: 8 }],
                    [{ text: 'Model / Model', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.type}`, fontSize: 8 }],
                    [{ text: 'Çözünürlük / Resolution', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.resolution}`, fontSize: 8 }],
                    [{ text: 'Lab. Kabul Tarihi / Lab. Date', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.range}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              // Tabloların altındaki ek bilgiler
            ],
            margin: [0, 0, 0, 0],
          },
          {
            table: {
              widths: ['25%', '75%'],
              body: [
                [{ text: `Cihazın Kalibrasyon Yapıldığı Yer`, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.incomingDateOfDeviceLaboratory}`, fontSize: 8 }],
                [{ text: `Görsel ve Fonksiyonel Kontrol    `, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.visualFunctionInspectionDevice}`, fontSize: 8 }]
              ],
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyonda Kullanılan Cihazlar /", bold: true, fontSize: 10 },
                      { text: "References used in calibration", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ['27%', '13%', '13%', '14%', '10%', '10%', '13%'], // 7 sütun için genişlikleri belirledim
                  body: [
                    [{ text: 'Cihaz Adı', fontSize: 8, bold: true }, { text: 'Marka', fontSize: 8, bold: true }, { text: 'Model', fontSize: 8, bold: true }, { text: 'Seri No', fontSize: 8, bold: true }, { text: 'Sertifika No', fontSize: 8, bold: true }, { text: 'Kal. Tarihi', fontSize: 8, bold: true }, { text: 'İzlenebilirlik', fontSize: 8, bold: true }],
                    [{ text: 'Device Name', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Brand', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Model', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Serial No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Certificate No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Cal. Date', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Tracebility', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }],
                    ...calibrationPage2?.references?.map(ref => [
                      { text: ref.deviceName, fontSize: 8 },
                      { text: ref.brand, fontSize: 8 },
                      { text: ref.model, fontSize: 8 },
                      { text: ref.serialNumber, fontSize: 8 },
                      { text: ref.certificateNumber, fontSize: 8 },
                      { text: ref.calibrationDate, fontSize: 8 },
                      { text: ref.tracebility, fontSize: 8 } // İzlenebilirlik için örnek veri (isteğe bağlı)
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }

            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Çevre Şartları /", bold: true, fontSize: 10 },
                      { text: "Environment Conditions", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ["*", "*", "*"],
                  body: [
                    [{ text: "Tür / Kind", bold: true, fontSize: 8 }, { text: "Başlangıç / Start", bold: true, fontSize: 8 }, { text: "Bitiş / End", bold: true, fontSize: 8 }],
                    ...(calibrationPage2.evironmentalConditions || []).map(ref => [
                      { text: ref.name || "-", fontSize: 7 },
                      { text: ref.start || "-", fontSize: 7 },
                      { text: ref.end || "-", fontSize: 7 },
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyon Metodu /", bold: true, fontSize: 10 },
                      { text: "Calibration Method", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [calibrationText],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Açıklama /", bold: true, fontSize: 10 },
                      { text: "Remarks", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [remaksToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Uygunluk Beyanı /", bold: true, fontSize: 10 },
                      { text: "Statement Of Complance", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [complianceToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Ölçüm Belirsizliği /", bold: true, fontSize: 10 },
                      { text: "Measurement Uncertaintily", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [measurementToHtml]
              }
            ]
          },
        ],
        marginTop: -100
      },
      // Sayfa sonu eklemeleri (isteğe bağlı)
      { text: '', pageBreak: 'after' }, // Eğer sayfa sonu gerekiyorsa, sayfa kesme ekleyebilirsiniz
    ];
  }

  createCalibrationOtherPage(imgData: string[]) {
    const pageContent = [];
    // Sayfa başına bir görsel ekliyoruz ve her sayfada bir kırılma ekliyoruz.
    for (let i = 0; i < imgData.length; i++) {
      pageContent.push({
        image: imgData[i],
        alignment: 'center',
        fit: [580, 1400], // sayfaya sığacak şekilde
        //width:1200,
        //height:1440,
        margin: [0, 0, 0, 0], // Görsel ile header arasına boşluk bırakabiliriz
        absolutePosition: { x: 60, y: 100 }, // Y konumunu her sayfa için ayarlayabilirsiniz
        pageBreak: i < imgData.length - 1 ? 'after' : undefined // Son görselden sonra sayfa kırılması ekliyoruz
      });
    }
    return pageContent;
  }

  async mergePdfWithBase64(base64Pdf1: string, base64Pdf2: string): Promise<string> {

    // Base64 → Uint8Array
    const pdf1Bytes = Uint8Array.from(atob(base64Pdf1), c => c.charCodeAt(0));
    const pdf2Bytes = Uint8Array.from(atob(base64Pdf2), c => c.charCodeAt(0));

    // PDF'leri yükle
    const pdf1 = await PDFDocument.load(pdf1Bytes);
    const pdf2 = await PDFDocument.load(pdf2Bytes);

    // Yeni PDF oluştur (birleştirme için)
    const mergedPdf = await PDFDocument.create();

    // PDF1 sayfalarını kopyala
    const pdf1Pages = await mergedPdf.copyPages(pdf1, pdf1.getPageIndices());
    pdf1Pages.forEach(page => mergedPdf.addPage(page));

    // PDF2 (measurement) sayfalarını kopyala
    const pdf2Pages = await mergedPdf.copyPages(pdf2, pdf2.getPageIndices());
    pdf2Pages.forEach(page => mergedPdf.addPage(page));

    // Base64 olarak çıktı
    const mergedPdfBase64 = await mergedPdf.saveAsBase64({ dataUri: false });

    return mergedPdfBase64;
  }

  // Header content function
  getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData: headerBilgileri) {
    console.log("header akr fir : ", headerData.acradtionOrganizationId);
    return {
      stack: [
        {
          columns: [
            // Sol kolon
            { ...this.getLeftColumn(headerData, currentPage, pageCount), width: '25%' },

            // Orta kolon (esnek)
            {
              ...this.getCenterColumn(headerData, currentPage), width: '52%' // sağdaki tabloya 2 birim boşluk bırak
            },

            // Other logo (sağ logosu, tablo ile 2 birim boşluk bırak)
            headerData.acradtionOrganizationId != 3 ? {
              ...this.getOtherLogoColumn(headerData, currentPage),
              width: '*',
              margin: [0, 0, 2, 0], // sağdaki tabloya 2 birim boşluk bırak
            } :
              {
                text: '', width: '*',
                margin: [0, 0, 2, 0],
              },

            // Sağ kolon (tablo)
            {
              ...this.getRightColumn(
                akraditasyonFirma,
                headerData.akraditationNo,
                headerData.certificateNo,
                headerData.certificateTarih,
                currentPage,
                headerData.firmaAdi?.split(' ')[0],
                headerData.acradtionOrganizationId
              ),
              width: 'auto',
              // alignment: 'right'
            },
          ],
          margin: [35, 12, 35, 0],
        },
        {
          text: `Sayfa (Page): ${currentPage} / ${pageCount}`,
          fontSize: 8,
          alignment: 'left',
          margin: [35, 2, 0, 0]
        },
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
      ],
    };
  }

  getOtherLogoColumn(headerData, currentPage) {
    const otherLogoStack: any[] = [];
    if (this.customerSetting.otherLogo && currentPage === 1) {
      otherLogoStack.push({
        image: this.customerSetting.otherLogo,
        fit: [75, 90],
        alignment: 'rigth',
        margin: [0, 0, 0, 0]
      });
    } else {
      otherLogoStack.push({ text: '', width: 90, height: 90, opacity: 0 });
    }

    return {
      stack: otherLogoStack,
      alignment: 'rigth',
      minHeight: 100,
      // marginleft: -10
    };
  }

  // Left column content
  getLeftColumn(headerData, currentPage, totalPages) {
    const logoStack: any[] = [];

    if (headerData.firmaLogo && currentPage == 1) {
      logoStack.push({
        image: headerData.firmaLogo,
        fit: [150, 150],
        margin: [0, -20, 0, 0],
        alignment: 'left'
      });

      // 🔹 QR Code logonun hemen altına
      if (this.qrCodeBase64) {
        logoStack.push({
          image: this.qrCodeBase64,
          fit: [75, 75],
          margin: [20, 5, 0, 0],
          alignment: 'rigth'
        });
      }

    } /*else {
      logoStack.push(
        { text: "", fontSize: 10, italics: true },
        {
          text: `Sayfa (Page): ${currentPage} / ${totalPages}`,
          fontSize: 8,
          margin: [0, currentPage == 1 ? 10 : 10, 0, 0],
          alignment: 'left',
        }
      );
    }*/

    return {
      stack: logoStack,
      alignment: 'left',
      minHeight: 100,
      marginTop: 25
    };
  }

  // Center column content
  getCenterColumn(headerData, currentPage) {
    return {
      stack: [
        {
          noWrap: false,
          text: `${headerData.firmaAdi}`,
          italics: true,
          bold: true,
          fontSize: 12,
          lineHeight: 1.1,
          margin: [15, headerData.firmaAdi.length && currentPage != 1 > 30 ? 10 : 20, 2, currentPage != 1 ? 10 : 0]
        },
        currentPage == 1 ? { text: `${headerData.firmaAdresi}`, italics: true, fontSize: 10, marginTop: 10, marginLeft: 10 } : { text: '' },

        currentPage == 1 ? { text: "KALİBRASYON SERTİFİKASI", bold: true, fontSize: 12, margin: [0, 25, 0, 0] } : { text: '' },
        currentPage == 1 ? { text: "Calibration Certificate", italics: true, fontSize: 8 } : { text: '' },
      ],
      alignment: 'center',
      marginTop: 20,
      marginLeft: 10
    };
  }

  // Right column content
  getRightColumn(
    akraditasyonFirma,
    akraditationNo,
    certificateNo,
    certificateTarih,
    currentPage,
    companyName,
    akradetionNumber
  ) {
    akraditationNo = this.customerSetting.accreditationNo;
    this.certificateFirstNo = this.customerSetting.certificatePrefix;
    const rightStack: any[] = [];
    // Üst logo
    if (currentPage === 1 && akraditasyonFirma) {
      rightStack.push({
        image: akraditasyonFirma,
        witdh: 85,
        height: 85,
        fit: [75, 90],
        alignment: 'center', //center dı
        margin: [0, 5, 0, 0]
        // margin: (akradetionNumber == 2 || akradetionNumber == 3) ? [-10, 0, 0, 0] : [-10, 0, 0, 0]
      });
    } else {
      rightStack.push({ text: '', width: 100, height: 100, opacity: 0 });
    }

    // 🔹 Turkak QR sadece akradetionNumber 1 ise tabloyu komple kaldır ve QR koy
    if (this.coreConfig.isCalibratedTurkak === true && akradetionNumber == 1 && currentPage == 1) {
      rightStack.push({
        image: this.turkakQrBase64,
        fit: [65, 65],
        alignment: 'center',
        margin: [0, 5, 0, 0]
      });
      rightStack.push({
        //text: `${akraditationNo.slice(3).replace(/-/g, '') + '-' + certificateTarih + '-' + certificateNo}`,
        text: `${this.certificationBodyDocumentNumber}`,
        fontSize: 7,
        margin: [0, 0, 0, 0],
      });
    } else {
      // Diğer durumlarda tabloyu koru
      rightStack.push({
        table: {
          widths: [47],
          body: [
            ...(akradetionNumber != 3
              ? [[{ text: akraditationNo, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]
              : [[{ text: companyName?.toUpperCase(), alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]),
            [{ text: `${this.certificateFirstNo}${certificateNo}`, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }],
            [{ text: certificateTarih, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }],
          ],
        },
        marginLeft: 3,
        marginTop: 10
      });
    }

    return {
      stack: rightStack,
      alignment: 'center',
      minHeight: 100
    };
  }

  // Footer content function
  getFooterContent(currentPage, pageCount, firstPageFooterDescription) {

    if (currentPage > 2) {
      return {};
    }

    console.log(firstPageFooterDescription);
    let firstPageFooterDescriptionToHtml = htmlToPdfmake(firstPageFooterDescription);
    firstPageFooterDescriptionToHtml = this.applyDefaultFontSize(firstPageFooterDescriptionToHtml, 8, 8);

    // İlk sayfa için footer içeriğini ayarlarken margin ve padding ekliyoruz.
    return {
      stack: [
        // Footer'da bir çizgi ekliyoruz
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
        {
          stack: [
            firstPageFooterDescriptionToHtml,
            ...(this.calibration.procedureFormNo ? [{ text: this.calibration.procedureFormNo, fontSize: 8 }] : [])
          ],
          margin: [35, 10, 35, 20], // Alt margin'ini biraz daha azaltarak daha fazla alan bırakıyoruz
          fontSize: 8, // Font boyutunu küçültüyoruz
        },

      ],
      margin: [0, 0, 0, 0]
    };
  }
}

export interface headerBilgileri {
  firmaLogo: string;
  firmaAdi: string;
  firmaAdresi: string;
  akraditationFirma: number;
  akraditationNo: string;
  certificateNo: string;
  certificateTarih: string;
  acradtionOrganizationId?: number;
}

export interface CalibrationData {
  deviceOwner: string;
  address: string;
  orderNumber: string;
  deviceName: string;
  manufacturer: string;
  modelType: string;
  serialNumber: string;
  calibrationDate: string;
  certificatePageNumber?: number;
  onaylayan: string;
  kalYapan: string;
  certificateNo: string;
  firstPageDescription: string;
  firtsPageFooterDescription: string;
  place: string;
}

export interface CalibrationPage2 {
  measurementUncertainty: string; // Ölçüm Belirsizliği
  calibrationMethod: string; // Kalibrasyon Yöntemi
  references: Reference[]; // Referanslar
  device: Device;
  remarks: string; // Açıklamalar
  evironmentalConditions: any[];
  compliance: string;
  measurement: string;
  description: string;
  reviseDescription?: string
}

export interface Device {
  deviceName: string;
  serialNo: string;
  deviceNumber: string;
  location: string;
  brand: string;
  type: string;
  range: string;
  resolution: string;
  incomingDateOfDeviceLaboratory: string;
  visualFunctionInspectionDevice: string;
}

export interface Reference {
  deviceName: string;
  brand: string;
  model: string;
  serialNumber: string;
  certificateNumber: string;
  calibrationDate: string;
  tracebility: string;
}